import { createFormAction } from 'redux-form-saga'

const getAllPressureMonitorsAction = createFormAction(
  'GET_ALL_PRESSURE_MONITORS'
)
const getPressureMonitorAction = createFormAction('GET_PRESSURE_MONITOR')
const createPressureMonitorAction = createFormAction(
  'CREATE_PRESSURE_MONITOR'
)
const updatePressureMonitorAction = createFormAction(
  'UPDATE_PRESSURE_MONITOR'
)
const deletePressureMonitorAction = createFormAction(
  'DELETE_PRESSURE_MONITOR'
)
const getAllAvailablePressureMonitorsBySiteAction = createFormAction(
  'GET_ALL_AVAILABLE_PRESSURE_MONITORS_BY_SITE'
)
const getPressureMonitorEditHistoryAction = createFormAction(
  'GET_PRESSURE_MONITOR_EDIT_HISTORY'
)
const getPressureMonitorAssignmentHistoryAction = createFormAction(
  'GET_PRESSURE_MONITOR_ASSIGNMENT_HISTORY'
)
const getPressureMonitorDataAction = createFormAction(
  'GET_PRESSURE_MONITOR_DATA'
)

export {
  getAllPressureMonitorsAction,
  getPressureMonitorAction,
  createPressureMonitorAction,
  updatePressureMonitorAction,
  deletePressureMonitorAction,
  getAllAvailablePressureMonitorsBySiteAction,
  getPressureMonitorEditHistoryAction,
  getPressureMonitorAssignmentHistoryAction,
  getPressureMonitorDataAction,
}
